import React, { Component } from 'react'
import PropTypes from 'prop-types'
import messages from './messages'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import { Button, Modal } from 'react-bootstrap'

class IssueResolvedModal extends Component {
  state = {
    showStyle: 'none'
  }

  static propTypes = {
    onHide: PropTypes.func
  }

  hideStyle() {
    this.setState({
      showStyle: 'none'
    })
  }

  showStyle() {
    this.setState({
      showStyle: 'block'
    })
  }

  render() {
    const translated = messages[this.props.language]

    return (
      <Modal
        {...this.props}
        bsSize="small"
        aria-labelledby="contained-modal-title-sm"
        dialogClassName="db-font-override"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-sm">
            {translated['title']}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {translated['help']}  <span className="fa fa-thumbs-up"></span>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.onHide}>{translated['close']}</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default LanguageProvider(IssueResolvedModal)



// WEBPACK FOOTER //
// ./src/components/IssueResolvedModal/IssueResolvedModal.js